<div class="modal-content">
  <empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
  <div class="modal-header">
    <h3 class="modal-title font">Motivo de baja</h3>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cerrar()">
      <span aria-hidden="true">&times;</span>
    </button>

  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">

    <!-- Formulario motivo de baja -->
    <form class="form-modal py-3" [formGroup]="formGroup">
      <div class="row-fields">
        <div class="field field-100">
          <label for="motivoBaja">Motivo de baja <span class="oblig">*</span></label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="motivoBaja" id="motivoBaja" placeholder="Motivo de baja">
              <mat-option *ngFor="let motivo of motivosBaja" [value]="motivo">
                {{motivo.descripcion}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="controlHasError('motivoBaja', 'required')">Campo obligatorio</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row-fields">
        <div class="field field-100">
          <label for="observacionesBaja">Observaciones baja</label>
          <div class="custom-mat-form-field-width">
            <mat-form-field appearance="outline" class="custom-mat-form-field-width">
              <input type="text" matInput formControlName="observacionesBaja" id="observacionesBaja"
                placeholder="Observaciones baja">
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <!-- FIN Formulario motivo de baja -->
  </div>
  <div class="modal-footer actions">
    <div class="note">* Campos Obligatorios</div>
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" data-dismiss="modal" (click)="cerrar()"
        aria-label="Cancelar">Cancelar</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="guardar()"
        aria-label="Guardar">Guardar</button>
    </div>
  </div>
</div>
